import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {LangChange} from '../../../../../lang-change';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {Utils} from '../../../../../common/services/Utils';
import {CollegeInfoService} from '../../../services/college-info.service';
import {CommonService} from '../../../../shared/services/common.service';
import {EnrollApplicationService} from '../../../services/enroll-application.service';
import {GovServiceApplication} from '../../../../../common/models/gov-service-application';
import {SscApplicationService} from '../../../../user/services/ssc.application.service';
import {EdsService} from '../../../../shared/services/eds.service';
import {FileService} from '../../../../shared/services/file.service';

@Component({
  selector: 'app-apply-gov-service-dialog',
  templateUrl: './apply-gov-service-dialog.component.html',
  styleUrls: ['./apply-gov-service-dialog.component.scss']
})
export class ApplyGovServiceDialogComponent extends LangChange implements OnInit {

  application = new GovServiceApplication(this.data.collegeId, this.data.serviceId, this.data.iin);
  student: any;
  selectedFile = {};
  ext: any;
  documents: any[];
  fileAllowedExtensions: string[];
  allFilesUploaded = false;

  constructor(public dialogRef: MatDialogRef<ApplyGovServiceDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private translateService: TranslateService,
              private _utils: Utils,
              private fileService: FileService,
              private collegeInfoService: CollegeInfoService,
              private _commonService: CommonService,
              private sscService: SscApplicationService,
              private _edsService: EdsService,
              private _enrollApplicationService: EnrollApplicationService) {
    super(translateService);
  }

  ngOnInit() {
    this.application.serviceId = this.data.serviceId;
    this.application.collegeId = this.data.collegeId;
    this.application.iin = this.data.iin;
    if (this.application.collegeId && this.application.iin) {
      this.sscService.getStudentByIIN(this.application.collegeId, this.application.iin).subscribe(
        data => {
          this.student = data;
          if (this.student) {
            this.application.lastName =  this.student.lastName;
            this.application.firstName =  this.student.firstName;
            this.application.patronymic =  this.student.patronymic;
          } /*else {
            this._utils.notifyError(this._translateService.instant('error_occurred'), null);
            this.onEsc();
          }*/
          this._utils.blockStop();
        }
      );
      this.getServiceDocs();
    }
    this.fileAllowedExtensions = ['.png', 'jpg', 'jpeg', '.pdf', '.doc', '.docx', '.rar'];
  }

  getServiceDocs(): void {
    this.sscService.getServiceDocs(this.application.serviceId).subscribe(data => {
      this.documents = data;
      this.documents = this._utils.translateListWithSort(this.documents, 'name');
      this.checkAllFilesUploaded();
    });
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.dialogRef.close();
  }

  onLangChange(langCode): void {
  }

  close(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this._edsService.signXmlCall('<data></data>', (signedXml) => {
      if (signedXml) {
        this.application.signedXml = signedXml;
        const formData: FormData = new FormData();
        formData.append('applicationDTO', JSON.stringify(this.application));
        for (const i in this.selectedFile) {
          formData.append('files', this.selectedFile[i], this.selectedFile[i].fileType + this.selectedFile[i].ext);
        }
        this.sscService.applyGovServiceApplication(formData).subscribe(
          response => {
            if (response.status === 'ERROR') {
              this._utils.notifyError(this._translateService.instant(response.description), null);
              return;
            }
            if (response.status === 'SUCCESS') {
              this._utils.notifySuccess(this._translateService.instant('enrolls_register.sent'), null);
              this.close();
            }
          },
          error => {
            console.error(error);
            this._utils.notifyError(this._translateService.instant('error_occurred'), null);
            return;
          }
        );
      }
    });
  }

  fileChange(event, doc) {
    const fileList: FileList = event.target.files;
    if (!fileList || !fileList.length) {
      this.selectedFile[doc.fileType] = null;
      return;
    }
    if (!this.isFileAllowed(fileList[0].name.toLowerCase())) {
      this._utils.notifyError(this.translateService.instant('ps.other_applications.msg_file_not_allowed'), null);
      return;
    }
    this.selectedFile[doc.fileType] = fileList[0];
    this.selectedFile[doc.fileType].ext = this.ext;
    this.selectedFile[doc.fileType].fileType = doc.fileType;
    doc.uploaded = true;
    event.target.value = '';
    this.checkAllFilesUploaded();
  }

  downloadFile(attr) {
    this.fileService.downloadFile(this.selectedFile[attr], this.selectedFile[attr].name,
      this.selectedFile[attr].type ? this.selectedFile[attr].type : 'application/octet-stream');
  }

  deleteFile(doc) {
    this.selectedFile[doc.fileType] = null;
    doc.uploaded = false;
    this.checkAllFilesUploaded();
  }

  isFileAllowed(fileName: string): boolean {
    for (let i = 0; i < this.fileAllowedExtensions.length; i++) {
      if (fileName.endsWith(this.fileAllowedExtensions[i])) {
        this.ext = '';
        this.ext = this.fileAllowedExtensions[i];
        return true;
      }
    }
    return false;
  }
  checkAllFilesUploaded() {
    let uploaded = true;
    this.documents.forEach(function (doc) {
      if (doc.required && !doc.uploaded) {
        uploaded = false;
      }
    });
    this.allFilesUploaded = uploaded;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/apply-gov-services/apply-gov-service-dialog/apply-gov-service-dialog.component.ts